module.exports = __webpack_public_path__ + "static/media/donde-estamos.2a51b2fd.jpeg";